import VpaUsageTable from './components/VpaUsageTable'

const VpaUsage = () => {
  return (
    <div><VpaUsageTable/></div>
  )
}

export default VpaUsage